// Constant values
const LOCAL_STORAGE_RECENTLY_VIEWED_KEY = "recently-viewed";
const RECENT_GRID_LOADED_CLASS = "loaded";
const RECENTLY_VIEWED_MAX_COUNT = 15;
const PRODUCT_HANDLE = Shopify.Products.productHandle || false;

// Selectors for DOM elements
const recentSelectors = {
  button: "[recently-viewed-wrapper]",
  grid: "[grid-recently-viewed]",
  productCard: ".wishlist-card .product-card",
  resetButton: "[button-recently-viewed-reset]",
};

// Event listener when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  if (PRODUCT_HANDLE) {
    updateRecentList(PRODUCT_HANDLE);
  }
  initRecentGrid();

  const resetRecentProdButton = document.querySelector(
    recentSelectors.resetButton
  );
  if (resetRecentProdButton) {
    resetRecentProdButton.addEventListener("click", () => {
      resetRecentProducts();
    });
  }
});

// Event listener for when the product grid is initialized
document.addEventListener(
  "shopify-recent-products:init-product-grid",
  (event) => {
    recentlyViewedSlider();
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }
);

// // Fetches the HTML content for a product card using its handle
const fetchRecentProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=product-card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const productCard = htmlDocument.documentElement.querySelector(
        recentSelectors.productCard
      );
      return productCard.outerHTML;
    })
    .catch((err) =>
      console.log(
        `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
        err
      )
    );
};

// Sets up the product grid with the recent products
const setupRecentGrid = async (grid) => {
  const recentProducts = getRecentList();
  const requests = recentProducts.map(fetchRecentProductCardHTML);
  const responses = await Promise.all(requests);
  const recentProductCards = responses.join("");
  grid.innerHTML = recentProductCards;
  grid.classList.add(RECENT_GRID_LOADED_CLASS);

  const event = new CustomEvent("shopify-recent-products:init-product-grid", {
    detail: { recentProducts: recentProducts },
  });
  document.dispatchEvent(event);
};

// Initializes the product grid
const initRecentGrid = () => {
  const grid = document.querySelector(recentSelectors.grid) || false;
  if (grid) {
    setupRecentGrid(grid);
  }
};

// Retrieves the recentProducts from local storage
const getRecentList = () => {
  const recentProductsJSON =
    localStorage.getItem(LOCAL_STORAGE_RECENTLY_VIEWED_KEY) || "[]";
  return JSON.parse(recentProductsJSON);
};

// Sets the recentProducts in local storage
const setRecentList = (array) => {
  const recentProductsJSON = JSON.stringify(array);
  localStorage.setItem(LOCAL_STORAGE_RECENTLY_VIEWED_KEY, recentProductsJSON);

  const event = new CustomEvent("shopify-recent-products:updated", {
    detail: { recentProducts: array },
  });
  document.dispatchEvent(event);

  return recentProductsJSON;
};

// Updates the recent Products with the given handle
function updateRecentList(handle) {
  let recentProducts = getRecentList();

  const indexInRecentProducts = recentProducts.indexOf(handle);
  if (indexInRecentProducts === -1) {
    if (recentProducts.length >= RECENTLY_VIEWED_MAX_COUNT) {
      recentProducts = recentProducts.slice(-RECENTLY_VIEWED_MAX_COUNT + 1);
    }
    recentProducts.push(handle);
  }
  return setRecentList(recentProducts);
}

// Checks if the recentProducts contains the given handle
const recentListContains = (handle) => {
  const recentProducts = getRecentList();
  return recentProducts.includes(handle);
};

// Resets the recent Products by clearing it in local storage
const resetRecentProducts = () => {
  return setRecentList([]);
};
